import { customElement, property, query } from 'lit/decorators.js';
import {
  API_TYPE_NIRVANA,
  WEB_COMPONENT_EXECUTIVE_SUMMARY_TOP_THREATS,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { html, PropertyValues, TemplateResult } from 'lit';
import { TopThreatsWebComponent } from '../../../../topThreats';
import { getTimezone } from '../../../../utils/global.utils';
import { translateFn } from '../../../../utils/translator.helper';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  GetTopThreatsBlockedResponse, TopThreatsBlockedPayload,
} from '@nirvana/shared/dtos/types/widgets/common';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';


@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_TOP_THREATS)
export class GzTopThreatsWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: TopThreatsBlockedPayload;

  @query('#gzTopThreatsBlocked')
  private topThreatsBlocked: TopThreatsWebComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getTopThreatsBlocked: function (request: GetWidgetDataRequest): Observable<GetTopThreatsBlockedResponse> {
              return of(this.getPayload().topThreatsBlocked);
            }.bind(this)
          }
        }
      }
    };

    if (this.topThreatsBlocked) {
      if (!this.topThreatsBlocked.started) {
        this.topThreatsBlocked.injectDependencies(dependencies);
        this.topThreatsBlocked.start();
      } else {
        this.topThreatsBlocked.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html `
      <gz-top-threats id="gzTopThreatsBlocked"
                      data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                      data-targets=${JSON.stringify(this.payload?.targets)}
                      data-can-drill-down=${true}
                      data-display-mode=${getDisplayMode()}
      ></gz-top-threats>`;
  }
}
